module.exports = __webpack_public_path__ + "img/bg2.7d38950e.png";